import {
    RECOMMENDATIONS_PROMOTION_GROUP,
    RECOMMENDATIONS_PROMOTION_GROUP_NAME,
} from "app/enums";
export const AnalyticsEventKeys = {
    // Main menu (desktop & mobile)
    ENTER_PAGE: 'enter_page',
    MENU_ITEM_PRESS: 'menu_item_press',
    MENU_CATEGORY_PRESS: 'menu_category_press',
    MENU_SUB_CATEGORY_PRESS: 'menu_sub_category_press',
    MENU_PERSONAL_ZONE_PRESS: 'menu_personal_zone_press',
    MENU_FAVORITES_PRESS: 'menu_favorites_press',

    UPSALE_POPUP_PRESENTED: 'upsale_popup_presented',
    VIEW_ITEM_LIST: 'view_item_list',
    ITEM_LIST_NAME: 'item_list_name',
    UPSALE_POPUP_PRODUCT_CLICK: 'upsale_popup_product_click',
    ALL_BENEFITS_UPSALE_POPUP_CLICK: 'all_benefits_upsale_popup_click',

    SELECT_ITEM: 'select_item',

    GALLERY_CAROUSEL_SCROLL_FORWARD: 'gallery_carousel_scroll_forward',
    GALLERY_CAROUSEL_SCROLL_BACK: 'gallery_carousel_scroll_back',

    SLIDER_CAROUSEL_SCROLL_FORWARD: 'slider_carousel_scroll_forward',
    SLIDER_CAROUSEL_SCROLL_BACK: 'slider_carousel_scroll_back',

    VIEW_PROMOTION: 'view_promotion',

    // Personal zone
    PERSONAL_ZONE_MENU_ITEM_PRESS: 'personal_zone_menu_item_press',
    EDIT_USER_INFORMATION: 'edit_user_information',

    // Authentication
    LOGIN: 'login',
    LOGIN_FAILED: 'login_failed',
    REGISTER: 'register',
    REGISTER_FAILED: 'register_failed',
    LOGOUT: 'logout',

    // Search
    QUICK_SEARCH: 'quick_search',
    HOT_SEARCH: 'hot_search',
    EMPTY_SEARCH: 'empty_search',
    SEARCH_PRESS: 'search_press',

    // Homepage
    HOMEPAGE_TOP_SLIDER_PRESS: 'homepage_top_slider_press',
    HOMEPAGE_SLIDER_TITLE_PRESS: 'homepage_slider_title_press',
    HOMEPAGE_SLIDER_TAB_PRESS: 'homepage_slider_tab_press',
    HOMEPAGE_SLIDER_BUTTON_PRESS: 'homepage_slider_button_press',
    HOMEPAGE_SLIDER_PROMOTION_SLIDE_PRESS: 'homepage_slider_promotion_slide_press',
    BANNER_PRESS: 'banner_press',

    // Benefits & products
    VIEW_ITEM: 'view_item',
    SELECT_PROMOTION: 'select_promotion',
    ADD_TO_CART: 'add_to_cart',
    PURCHASE: 'purchase',
    BENEFIT_PRESS: 'benefit_press',
    PRODUCT_PRESS: 'product_press',
    ADD_TO_FAVORITES: 'add_to_favorites',
    ADD_TO_WISHLIST: 'add_to_wishlist',
    REMOVE_FROM_FAVORITES: 'remove_from_favorites',
    BENEFIT_WEBSITE_OPEN: 'benefit_website_open',
    BENEFIT_GET_COUPON_CODE_PRESS: 'benefit_get_coupon_code_press',
    BENEFIT_GET_PAID_COUPON_PRESS: 'benefit_get_paid_coupon_press',
    CREDIT_CARD_POPUP_PRESENTED: 'credit_card_popup_presented',
    BENEFIT_PAID_COUPON_EDIT_USER_CARD: 'benefit_paid_coupon_edit_user_card',
    BENEFIT_PAID_COUPON_SUCCESS: 'benefit_paid_coupon_success',
    BENEFIT_PAID_COUPON_FAILED: 'benefit_paid_coupon_failed',
    PRODUCT_BUY_WITH_CLICK_PRESS: 'product_buy_with_click_press',
    PRODUCT_BUY_WITH_CLICK_SUCCESS: 'product_buy_with_click_success',
    PRODUCT_BUY_WITH_CLICK_FAILED: 'product_buy_with_click_failed',

    // Magazine
    MAGAZINE_SLIDER_PRESS: 'magazine_slider_press',
    ARTICLE_PRESS: 'article_press',
    VIDEO_ARTICLE_PRESS: 'video_article_press',

    // Insurance
    INSURANCE_SLIDER_PRESS: 'insurance_slider_press',
    INSURANCE_SLIDER_ITEM_PRESS: 'insurance_slider_item_press',

    // Leads
    LEAD_VENDOR: 'lead_vendor',
    LEAD_USER: 'lead_user',
    REQUEST_REASON: 'request_reason',
    BEGIN_CHECKOUT: 'begin_checkout',

    // Footer
    FOOTER_ITEM_PRESS: 'footer_item_press',
    SUBSCRIBE_NEWSLETTER: 'subscribe_newsletter',

    NEWSLETTER_SIGNUP_SUBMITTED: 'newsletter_signup_submitted',
    NEWSLETTER_SIGNUP_SUCCESS: 'newsletter_signup_success',
    NEWSLETTER_SIGNUP_FAILED: 'newsletter_signup_failed',
    NEWSLETTER_SIGNUP_PRESENTED: 'newsletter_signup_presented',

    // Others
    APP_STORE_LINK_PRESS: 'app_store_link_press',
    SOCIAL_MEDIA_LINK_PRESS: 'social_media_link_press',
    CONTACT_US_MESSAGE_SENT: 'contact_us_message_sent',
    REQUEST_MEMBERSHIP_CARD: 'request_membership_card',
    REQUEST_APP_DOWNLOAD: 'request_app_download',
    EXCEPTION: 'exception',
};

export const AnalyticsParamKeys = {
    CONTENT_TYPE: 'content_type',
    METHOD: 'method',
    ITEM_ID: 'item_id',
    ARTICLE_ID: 'article_id',
    ARTICLE_TITLE: 'article_title',
    BANNER_ID: 'banner_id',
    BENEFIT_ID: 'benefit_id',
    BENEFIT_OR_PRODUCT_ID: 'benefit_or_product_id',
    BENEFIT_OR_PRODUCT_TITLE: 'benefit_or_product_title',
    BENEFIT_TITLE: 'benefit_title',
    BUTTON_NAME: 'button_name',
    CATEGORY_ID: 'category_id',
    CATEGORY_TITLE: 'category_title',
    CURRENCY: 'currency',
    STATUS: 'status',
    ITEMS: 'items',
    ITEM_NAME: 'item_name',
    PRESS_SOURCE: 'press_source',
    MA_RECOMMENDED: 'ma_recommended',
    PRODUCT_ID: 'product_id',
    PRODUCT_TITLE: 'product_title',
    REQUEST_SOURCE: 'request_source',
    SEARCH_TERM: 'search_term',
    ITEM_VARIANT: 'item_variant',
    SLIDER_ID: 'slider_id',
    SLIDER_TITLE: 'slider_title',
    SLIDER_TYPE: 'slider_type',
    TAB_ID: 'tab_id',
    TAB_TITLE: 'tab_title',
    TRANSACTION_ID: 'transaction_id',
    USER_CITY_ID: 'user_city_id',
    USER_GENDER: 'user_gender',
    USER_ID: 'user_id',
    USER_WORKPLACE_ID: 'user_workplace_id',
    VALUE: 'value',
    VIDEO_ARTICLE_ID: 'video_article_id',
    VIDEO_ARTICLE_TITLE: 'video_article_title',
    REQUEST_REASON: 'request_reason',
    LOCATION: 'location',
    ECOMMERCE: 'ecommerce',
    CREATIVE_SLOT: 'creative_slot',
    PROMOTION_NAME: 'promotion_name',
    ITEM_LIST_NAME: 'item_list_name',
    PROMOTION_ID: 'promotion_id',
};

export const BAM_ONLY_KEYS = {
    PERSONAL_ID: 'personalId',
    CELLPHONE: 'cellphone',
    EMAIL: 'email',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
}


export const getRecommendationsPromotionsTypeLogValue = (recommendationsPromotionsType) => {
    if (recommendationsPromotionsType == null) return undefined;
    switch (Number(recommendationsPromotionsType)) {
        case RECOMMENDATIONS_PROMOTION_GROUP.DEFAULT_POPULAR:
            return RECOMMENDATIONS_PROMOTION_GROUP_NAME.DEFAULT_POPULAR;
        case RECOMMENDATIONS_PROMOTION_GROUP.RECOMMENDATIONS:
            return RECOMMENDATIONS_PROMOTION_GROUP_NAME.RECOMMENDATIONS;
        case RECOMMENDATIONS_PROMOTION_GROUP.DEFAULT_RECOMMENDATIONS:
            return RECOMMENDATIONS_PROMOTION_GROUP_NAME.DEFAULT_RECOMMENDATIONS;
        default:
            return undefined;
    }
};

export const AnalyticsParamValues = {
    // Sources
    HOMEPAGE_TOP_SLIDER_SOURCE: 'homepage_top_slider_source',
    HOMEPAGE_SLIDER_SOURCE: 'homepage_slider_source',
    HOMEPAGE_MAGAZINE_SOURCE: 'homepage_magazine_source',
    ALL_BENEFITS_PAGE_SOURCE: 'all_benefits_page_source',
    CATEGORY_PAGE_SOURCE: 'category_page_source',
    BENEFIT_PAGE_SOURCE: 'benefit_page_source',
    PRODUCT_PAGE_SOURCE: 'product_page_source',
    MAGAZINE_PAGE_SOURCE: 'magazine_page_source',
    MAGAZINE_SECTION_PAGE_SOURCE: 'magazine_section_page_source',
    MAGAZINE_ARTICLE_PAGE_SOURCE: 'magazine_article_page_source',
    SEARCH_RESULTS_SOURCE: 'search_results_source',
    UNKNOWN_SOURCE: 'unknown_source',
    SHARE: 'share',

    // Personal zone
    MY_ORDERS: 'my_orders',
    PERSONAL_DETAILS: 'personal_details',
    ADDRESS: 'address',
    PAYMENT_METHODS: 'payment_methods',
    LOGOUT: 'logout',

    // Homepage sliders
    NORMAL_BENEFITS_SLIDER: 'normal_benefits_slider',
    RECOMMENDATIONS_BENEFITS_SLIDER: 'recommendations_benefits_slider',
    CATEGORY_BENEFITS_SLIDER: 'category_benefits_slider',
    INSURANCE_ITEMS_SLIDER: 'insurance_items_slider',
    DEFAULT_TAB: 'default_tab',
    NEWS_LETTER_FORM: 'newsletter',
    // Currency
    ILS_CURRENCY: 'ILS',
};
